<template>
  <div :class="$style.modalWrapper">
    <modal
      classes="show-video-modal"
      :is-shown="isShown"
      :is-close-button-shown="false"
      :on-close="handleClose"
      @closeModal="isShown = false"
    >
      <div
        slot="body"
        :class="$style.videoContainer"
        :style="
          dimensionPercentage ? `padding-bottom: ${dimensionPercentage}%` : ''
        "
      >
        <iframe
          ref="iframe"
          :src="
            `https://player.vimeo.com/video/${videoId}?autopause=0&loop=0&autoplay=1&muted=0&title=0`
          "
          style="position:absolute;left:0;top:0;width:100%;height:100%;"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          :allow="
            `${
              (isAutoplay && !isWatched) || isAutoplayByClick
                ? 'autoplay'
                : 'fullscreen'
            }`
          "
        ></iframe>
        <!-- https://player.vimeo.com/video/372741466?title=0&byline=0&portrait=0 -->
        <!-- <iframe
          ref="iframe"
          src="https://player.vimeo.com/video/372741466"
          width="640"
          height="338"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>-->
      </div>
    </modal>
    <button
      type="button"
      v-if="!isAutoplay"
      class="sv-btn sv-btn--link"
      @click.prevent="isShown = true"
      :data-recorded-action="`${section ? `${section}: ` : ``}Video Image`"
    >
      <play-icon />
    </button>
  </div>
</template>

<script>
import PlayIcon from "./Icons/Play";
import Modal from "./Modal";
// import { getCookie, setCookie } from "utils/storage";

export default {
  components: {
    Modal,
    PlayIcon
  },
  props: {
    videoId: {
      type: String,
      required: true
    },
    isAutoplay: {
      type: Boolean,
      default: false
    },
    isAutoplayByClick: {
      type: Boolean,
      default: false
    },
    subtitles: {
      type: Boolean,
      default: false
    },
    section: {
      type: String,
      required: false,
      default: ""
    },
    dimensionPercentage: {
      // type: String,
      required: false
    },
    onOpen: {
      type: Function,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    // const isWatchedArray = JSON.parse(getCookie("isWatched") || "[]");
    // const isWatched = isWatchedArray.includes(this.videoId);

    return {
      isWatched: false,
      isShown: this.isAutoplay,
      player: null
    };
  },
  mounted() {
    this.$nextTick(function() {
      if (this.isAutoplay && !this.isWatched) {
        const playerEmbedded = document.querySelector(
          '[src*="https://player.vimeo.com/api/player.js"]'
        );

        if (!playerEmbedded) {
          const script = document.createElement("script");
          script.async = true;
          script.src = "https://player.vimeo.com/api/player.js";
          script.onload = () => {
            this.player = new window.Vimeo.Player(this.$refs.iframe);
          };
          document.body.appendChild(script);
        }
      }
    });

    this.$watch(
      vm => {
        return { isShown: vm.isShown, player: vm.player };
      },
      function(newVal, oldVal) {
        if (newVal.isShown && !oldVal.isShown) {
          this.vimeoInterval = setInterval(() => {
            if (window.Vimeo) {
              this.player = new window.Vimeo.Player(this.$refs.iframe);
              clearInterval(this.vimeoInterval);
            }
          }, 150);
        }

        // if (newVal.isShown && newVal.player && !oldVal.player) {
        //   this.player.play();
        //   const isWatchedArray = JSON.parse(getCookie("isWatched") || "[]");
        //   isWatchedArray.push(this.videoId);
        //   const date = new Date();
        //   date.setMinutes(date.getMinutes() + 10);
        //   const expires = date.toUTCString();
        //   setCookie({
        //     name: "isWatched",
        //     value: JSON.stringify(isWatchedArray),
        //     path: location.pathname,
        //     expires
        //   });

        //   this.player.on("ended", () => {
        //     this.isShown = false;
        //   });
        // }

        if (!newVal.isShown && oldVal.isShown && newVal.player) {
          this.player.destroy();
          setImmediate(() => {
            this.player = null;
          });
        }
      }
    );
  },
  beforeDestroy() {
    if (this.player) {
      this.player.off("timeupdate");
      this.player.stop();
    }
    clearInterval(this.vimeoInterval);
  },
  methods: {
    handleClose: function() {
      this.isShown = false;
    }
  }
};
</script>

<style lang="scss" module>
.modalWrapper {
  :global {
    .modal-container {
      height: auto;
      padding: 0;
      width: 800px;
      max-width: 100vw;
      box-shadow: none;
      background-color: transparent;
    }
    .modal-body {
      padding: 0;
    }
  }
}
.videoContainer {
  position: relative;
  // padding-bottom: 56.25%;
  padding-bottom: percentage(338/640);
}
</style>
<style lang="scss">
div.show-video-modal {
  z-index: 10001;
}
</style>
